export const firebaseConfig = {
    apiKey: "AIzaSyCDthcCrOYOi2t9G7n8Waugsq8EW70oE6c",
    authDomain: "hbrc-18a6e.firebaseapp.com",
    databaseURL: "https://hbrc-18a6e.firebaseio.com",
    projectId: "hbrc-18a6e",
    storageBucket: "hbrc-18a6e.appspot.com",
    messagingSenderId: "757016957385",
    appId: "1:757016957385:web:73367ef6cb18b892995818"
  };